import React from 'react'
import { Container } from '@nextui-org/react'
import { Flex } from '@mantine/core'
import { Player } from '@lottiefiles/react-lottie-player'
import Page from 'components/Layout/Page'


const PageLoader: React.FC = () => {
  return (
    <Page style={{
      width: '100%',
      background: 'var(--blackColor)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      minHeight: '100vh',
    }}>
      <Container style={{
        paddingTop: '20px',
      }}>
        <Flex
          direction="column"
          justify="center"
          align="center"
        >
          <Player
            src='/images/loading-icon.json'
            className="player"
            loop
            autoplay
            style={{ height: '600px', width: '600px', marginTop: '160px' }}
          />
        </Flex>
      </Container>
    </Page>
  )
}

export default PageLoader